import { styled } from '@cp/ds/src/theme';
import { Box } from '@cp/ds/src/components/box';
import { Tokens, name } from './const';

const FooterBox = styled(Box, { name, slot: 'Footer' })(({ theme }) => ({
  color: Tokens.textColor(),
  paddingTop: theme.spacing(1),
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1),
  '&:empty': {
    display: 'none',
  },
}));

export const Footer = FooterBox;
